"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomStepper = function (_Component) {
    (0, _inherits3.default)(CustomStepper, _Component);

    function CustomStepper() {
        (0, _classCallCheck3.default)(this, CustomStepper);
        return (0, _possibleConstructorReturn3.default)(this, (CustomStepper.__proto__ || Object.getPrototypeOf(CustomStepper)).apply(this, arguments));
    }

    (0, _createClass3.default)(CustomStepper, [{
        key: "render",

        // Assuming activeStep is now controlled by Redux or parent state passed via props
        // The state inside this component is removed.

        value: function render() {
            var _props = this.props,
                steps = _props.steps,
                activeStep = _props.activeStep,
                handleNext = _props.handleNext,
                handleBack = _props.handleBack;


            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    _core.Stepper,
                    { activeStep: activeStep, alternativeLabel: true },
                    steps.map(function (step, index) {
                        return _react2.default.createElement(
                            _core.Step,
                            { key: index },
                            _react2.default.createElement(
                                _core.StepLabel,
                                null,
                                step.label
                            )
                        );
                    })
                )
            );
        }
    }]);
    return CustomStepper;
}(_react.Component);

exports.default = CustomStepper;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/CustomStepper/index.js
// module id = 2146
// module chunks = 1137